export default __webpack_public_path__ + "static/media/pinkuser.9d93cbdb.png";